import AppBar from '@material-ui/core/AppBar';
import { makeStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import React from 'react';
import styles from './BottomNav.module.scss';

const useStyles = makeStyles((theme) => ({
  text: {
    padding: theme.spacing(2, 2, 0),
  },
  paper: {
    paddingBottom: 50,
  },
  list: {
    marginBottom: theme.spacing(2),
  },
  subheader: {
    backgroundColor: theme.palette.background.paper,
  },
  appBar: {
    top: 'auto',
    bottom: 0,
    width:"100%"
  },
  grow: {
    flexGrow: 1,
  },
  fabButton: {
    position: 'absolute',
    zIndex: 1,
    top: -30,
    left: 0,
    right: 0,
    margin: '0 auto',
  },
}));

export default function BottomAppBar({ children }) {
  const classes = useStyles();

  return (
    <div>
      <AppBar position="fixed" color="primary" className={`${classes.appBar} ${styles.bottomNav}`} >
        <Toolbar>
          <div className={classes.grow} />
          <div className={styles.paginatorContainer}>
              {children}
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
}